import sliceCreator from '../../index.jsx';
import {UPDATE_VILLAGE} from '../../../constants/index.jsx';
const _updateVillageAction = sliceCreator('UPDATE_VILLAGE', UPDATE_VILLAGE, 'put');

const { asyncAction: updateVillageAction, reducer, clearData: clearUpdateVillageAction } = _updateVillageAction;

export default reducer;

export {
    updateVillageAction,
    clearUpdateVillageAction
}